import { StateCreator } from 'zustand'
import ContentManagerService from 'service/ContentManagerService'
import { errorHandling } from 'store/utils/provider'

import {
  ContentManagerState,
  DEFAULT_CONTENT_MY_TITLES,
  DEFAULT_CONTENT_CAPITALIZATION,
  DEFAULT_CONTENT_TITLE,
} from './types'

export const createContentManagerSlice: StateCreator<
  ContentManagerState,
  [],
  [],
  ContentManagerState
> = (set) => ({
  contentCapitalization: DEFAULT_CONTENT_CAPITALIZATION,
  contentTitle: DEFAULT_CONTENT_TITLE,
  contentMyTitle: DEFAULT_CONTENT_MY_TITLES,

  getContentManager: async () => {
    try {
      const response = await ContentManagerService.getContentManager()

      const capitalizationParam = response?.params?.find((param) => param.name === 'CAPITALIZATION')
      const titleParam = response?.params?.find((param) => param.name === 'TITLE')
      const myTitleParam = response?.params?.find((param) => param.name === 'MY_TITLE')

      if (capitalizationParam) {
        set(() => ({
          contentCapitalization: {
            value1: capitalizationParam.value1,
            value1Lowercase: capitalizationParam.value1.toLowerCase(),
            value2: capitalizationParam.value2,
            value2Lowercase: capitalizationParam.value2.toLowerCase(),
          },
        }))
      }

      if (titleParam) {
        set(() => ({
          contentTitle: {
            value1: titleParam.value1,
            value1Lowercase: titleParam.value1.toLowerCase(),
            value2: titleParam.value2,
            value2Lowercase: titleParam.value2.toLowerCase(),
          },
        }))
      }

      if (myTitleParam) {
        set(() => ({
          contentMyTitle: {
            value1: myTitleParam.value1,
            value1Lowercase: myTitleParam.value1.toLowerCase(),
            value2: myTitleParam.value2,
            value2Lowercase: myTitleParam.value2.toLowerCase(),
          },
        }))
      }
    } catch (error) {
      errorHandling(error as Error, 'ContentManagerService/getContentManager')
    }
  },
})
